import Api from '../../../Api'
import { all, takeEvery, call, put, select } from 'redux-saga/effects'
import { combineReducers } from "redux";
import createTableFetcher from 'common/reducer/createTableFetcher'

// ES6
const getFetcher = state => {
    return state.waas.stats.fetcher
}
export const fetcher = createTableFetcher('stats', Api.fetchServerTree, getFetcher)

export const types = {
    SET_IS_LOADING: 'APPLICATIONS_TABLE/SET_IS_LOADING',
    UPDATE_STATS: 'APPLICATIONS_TABLE/UPDATE_STATS',
    FETCH_GLOBAL_DC_STATS: 'APPLICATIONS_TABLE/FETCH_GLOBAL_DC_STATS',
    SET_FILTER: 'APPLICATIONS_TABLE/SET_FILTER',
}

export const actions = {
    setFilter: (value) => ({ type: types.SET_FILTER, value }),
    fetchGlobalDcStats: () => ({ type: types.FETCH_GLOBAL_DC_STATS }),
    updateStats: (data) => ({ type: types.UPDATE_STATS, data }),
    setIsLoading: (isLoading) => ({ type: types.SET_IS_LOADING, isLoading }),
    toggleRenameDialog: (id = undefined, name = '') => ({ type: types.TOGGLE_RENAME_DIALOG, id, name }),
    ...fetcher.actions
}

export const initialState = {
    isLoading: false,
    items: [],
    dcStats: {},
    filterDate: '24h',
}

const stats = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case types.UPDATE_STATS:
            return {
                ...state,
                dcStats: action.data,
            };
        case types.SET_FILTER:
            // debugger
            return {
                ...state,
                filterDate: action.value,
            };
        default:
            return state;
    }
}

export function* fetchGlobalDcStats(action) {
    try {
        yield put(actions.setIsLoading(true));
        const store = yield select();
        const filterDate = store.waas.stats.stats.filterDate
        const results = yield call(Api.fetchGlobalDcStats, { rng: 'r_'+filterDate});
        yield put(actions.updateStats(results));
        yield put(actions.setIsLoading(false));
    } catch (e) {
    }
}

export default combineReducers({
    stats,
    fetcher: fetcher.reducer
});

export function* applicationTableFlow() {
    yield takeEvery(types.FETCH_GLOBAL_DC_STATS, fetchGlobalDcStats);
    yield takeEvery(types.SET_FILTER, fetchGlobalDcStats);
}

export function* statsSaga() {
    yield all([
        fetcher.saga(),
        applicationTableFlow(),
    ])
}